import { render, staticRenderFns } from "./VsSimpleViewUpload.vue?vue&type=template&id=02ca1274&"
import script from "./VsSimpleViewUpload.vue?vue&type=script&lang=js&"
export * from "./VsSimpleViewUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports